module.exports = __webpack_public_path__ + "static/logo-mikrofon-2e901109151f444d13b40223f3ae293b.png";